import httpService from '@/modules/common/services/httpService';

const baseRoute = '/business/staffs/v2/staffs';
const baseRouteV3 = 'v3/business_administration';

const fetchStaffData = async (staffUid, businessUid) => httpService.get(`/platform/v1/businesses/${businessUid}/staffs/${staffUid}`)
  .then((res) => res.data?.data?.staff[0]);

const fetchQuickActions = async (showOnlyVisible) => httpService.get(`${baseRouteV3}/staff_quick_action_lists`, { show_only_visible: showOnlyVisible }).then((res) => res.data);

const updateQuickActions = async (quickActions, staffUid) => httpService.put(`${baseRouteV3}/staff_quick_action_lists/${staffUid}`, quickActions).then((res) => res.data);

const fetchPermissions = async (staffUid) => httpService.get(`${baseRoute}/${staffUid}/permissions`)
  .then((res) => {
    const response = res.data?.data?.permissions;
    const permissions = Object.keys(response).filter((permission) => response[permission]);
    return permissions;
  });

const fetchAllStaff = async () => httpService.get('/v2/staffs')
  .then((res) => res.data?.data);

const setDefaultPage = async (staffUid, defaultPage) => {
  try {
    const response = await httpService.put(`/v2/staffs/${staffUid}`, {
      on_entry_navigate_to: defaultPage,
    });
    return response.data?.data;
  } catch (error) {
    // Handle network errors or other unexpected errors
    console.error('error', error);
    throw new Error('Failed to update default page. Please try again later.');
  }
};

const updateSkipTodoFlag = async (businessUid, skipTodoPage) => httpService.put(`/v2/business_flags/${businessUid}`, { skip_todo_page: skipTodoPage })
  .then((res) => res.data);

const fetchStaffMemberData = async (staffUid) => httpService.get(`/v3/business_administration/staff_members/${staffUid}`)
  .then((res) => res.data?.data);

const updateStaffMemberData = async (staffUid, staffData) => {
  const res = await httpService.put(`/v3/business_administration/staff_members/${staffUid}`, staffData);
  const data = res.data?.data;

  if (data?.errors) {
    const error = new Error(data.errors[0]?.message || 'Staff member update failed');
    error.response = { data };
    throw error;
  }

  if (!data) {
    throw new Error('No data returned from staff member update');
  }

  return {
    status: res.status,
    data,
  };
};

const fetchStaffSlots = async (businessUid) => httpService.get(`/platform/v1/businesses/${businessUid}/staff_slots`)
  .then((res) => res.data?.data);

// eslint-disable-next-line import/prefer-default-export
export const staffService = {
  fetchPermissions,
  fetchStaffData,
  fetchAllStaff,
  setDefaultPage,
  fetchQuickActions,
  updateQuickActions,
  updateSkipTodoFlag,
  fetchStaffMemberData,
  updateStaffMemberData,
  fetchStaffSlots,
};
